import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a3152d614f1f20014618170_1783699554299_4d1a8b2c/shine_1781617366180/src/app/shine/page.tsx");
